import React from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";

const MetaDecorator = ({
  title,
  description,
  imageUrl,
  imageAlt,
  keyword,
  jsonLd,
}) => {
  const defaultJsonLd = {
    "@context": "https://schema.org/",
    "@graph": [
      {
        "@type": "Organization",
        legalName: "Leapon Software Corp.",
        description:
          "Leapon combines the power of a digital business card with smart contact management, communication, and scheduling tools, giving you everything you need to thrive in one place",
        logo: "https://leapon-media.s3.amazonaws.com/media/webp_images/Group_1_png.webp",
        name: "Leapon",
        sameAs: [
          "https://m.facebook.com/people/LeapoN/100089010861110/",
          "https://www.linkedin.com/company/leapon/?viewAsMember=true",
          "https://www.instagram.com/leapon.co/",
        ],
        url: "https://leapon.tech/",
      },
      {
        "@type": "WebSite",
        name: "Leapon",
        url: "https://leapon.tech",
        potentialAction: {
          "@type": "SearchAction",
          target: "https://leapon.tech/?s={search_term_string}",
          "query-input": "required name=search_term_string",
        },
      },
    ],
  };

  return (
    <Helmet>
      <title>{title}</title>
      <meta property="og:title" content={title} />
      <meta name="description" content={description} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl} />
      <meta
        property="og:url"
        content={window.location.pathname + window.location.search}
      />
      <link
        rel="canonical"
        href={`https://leapon.tech${window.location.pathname}`}
      />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:image:alt" content={imageAlt} />
      <meta name="keyword" content={keyword} />
      <script type="application/ld+json">
        {JSON.stringify(jsonLd || defaultJsonLd)}
      </script>
    </Helmet>
  );
};

MetaDecorator.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  imageUrl: PropTypes.string,
  imageAlt: PropTypes.string,
  keyword: PropTypes.string,
  jsonLd: PropTypes.object,
};

export default MetaDecorator;
